import { Component, ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController,} from 'ionic-angular';

/**
 * Generated class for the EmailTemplatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-email-template',
  templateUrl: 'email-template.html',
})
export class EmailTemplatePage {

  // @ViewChild('ioninput') ioninputRef: ElementRef;
  @ViewChild('myInput') myInput;
  assessmentNameTag = ['#clientfirstname ','#clientlastname ','#parentname ','#practitionertitle ', '#practitionerfirstname ', '#practitionerlastname ', '#profession '];

  sendEmail: { title: string, subject: string, body: string, default: boolean } = {
    title: '',
    subject: '',
    body: '',
    default: false
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
    //this.sendEmail.title = 'Email Template'
    //this.sendEmail.subject = 'Hello' + ` ` + "assessment request";
    //this.sendEmail.body = "Dear "  + `,

//This is an automated email setup by `  + `who would like you to fill in a questionnaire to check in with you. Please click the link below and follow the prompts to fill in the assessment. The results will be available to ` + ` once you have submitted the assessment.
//Thank you.` + `\n` + `\n` +
if (this.navParams.data.template) {
  this.sendEmail.body = this.navParams.data.template.body;
  this.sendEmail.title = this.navParams.data.template.title;
  this.sendEmail.subject = this.navParams.data.template.subject;
  this.sendEmail.default = this.navParams.data.template.default;
}


this.getLifeLineText();
    
  }

  getLifeLineText() {
    
      return `If you are in need urgent assistance please contact Lifeline on 13 11 14.`
    
}

  ionViewDidLoad() {
    
  }

  saveTemplate(){
    this.viewCtrl.dismiss({template: this.sendEmail, dismiss:'done'});
  }

  onSelected(textToInsert) {
    this.myInput.setFocus();
    document.execCommand('insertText', false /*no UI*/, textToInsert);
  }

  cancel() {
    this.viewCtrl.dismiss({template: this.sendEmail, dismiss:'cancel'});
  }

  deleteTemplate(){
    this.viewCtrl.dismiss({template: this.sendEmail, dismiss:'delete'})
  }

}



// WEBPACK FOOTER //
// ./src/pages/email-template/email-template.ts